import type { LicenseResponseSchema } from "@/hera-api/client/types.gen";
import { formatCurrency } from "@/lib/utils";

const OPTIONAL_NOTE_DESCRIPTION =
  "You can add an optional note explaining your decision.";

type DueFields = Pick<LicenseResponseSchema, "total_due" | "due_this_period">;

function firstPositiveDue(data: DueFields): string | null {
  for (const value of [data.total_due, data.due_this_period]) {
    if (value == null || value === "") {
      continue;
    }
    const amount = Number.parseFloat(value);
    if (!Number.isNaN(amount) && amount > 0) {
      return value;
    }
  }
  return null;
}

export function licenseHasOutstandingBalance(data: DueFields): boolean {
  return firstPositiveDue(data) != null;
}

export function approveRegistrationDialogDescription(
  status: LicenseResponseSchema["status"] | string,
  data: DueFields,
): string {
  const due = firstPositiveDue(data);
  if (status === "PAID_PENDING_REVIEW" && due != null) {
    return `A fee of ${formatCurrency(due)} is due. Are you sure you want to continue? Any unpaid periods will be marked as paid in full. You can add an optional note explaining your decision.`;
  }
  return OPTIONAL_NOTE_DESCRIPTION;
}
